export function arrayOfStringsToString<T = any>(collection: T[]) {
  return collection.toString();
}
